import { Controller } from "stimulus"
import $ from 'jquery';

export default class extends Controller{
    connect() {

    }

    sendToAnotherList(e){
        let id = e.currentTarget.dataset.id
        let sendToWhiteListUrl = `${location.origin}/admin/security/send_to_white/${id}`;
        let sendToBlackListUrl = `${location.origin}/admin/security/send_to_black/${id}`;
        let url = '';
        if(id === undefined){
            let element = e.currentTarget.parentNode;
            id = element.dataset.id;
        }
        $.blockUI({ message:false });
        url = e.currentTarget.id === 'btn-whiteList' ? sendToBlackListUrl : sendToWhiteListUrl;
        $.ajax({
            url: url,
            data: {
                format: "json"
            },
            type: 'POST',
            success: function (data){
                setTimeout(function(){
                    if(data.success === true){
                        $.unblockUI();
                        console.log(data)
                    }
                },50000);

            },
            error: function(jqXHR, textStatus, errorThrown){
                $.unblockUI();
                let message = "";
                if (jqXHR.status === 0) {
                    message = 'Sin conexión: Verifique su conexión de red.';
                } else if(jqXHR.status == 400){
                    message = ' Existen problemas en el request';
                } else if(jqXHR.status == 401){
                    message = 'Autentiquece nuevamente.';
                }else if (jqXHR.status == 403) {
                    message = "Autentiquece nuevamente.";
                } else if (jqXHR.status == 404) {
                    message = 'Página no encontrada [404]';
                } else if (jqXHR.status == 500) {
                    message = 'Ha ocurrido un error [500] que fue notificado al equipo de soporte, intene nuevamente en unos minutos.';
                } else if (jqXHR.status == 503){
                    message = "Service unavailable.";
                } else if (textStatus === 'parsererror') {
                    message = 'Ha ocurrido un error de interno [JSON] que fue notificado al equipo de soporte, intene nuevamente en unos minutos';
                } else if (textStatus === 'timeout') {
                    message = 'Time out, tiempo de espera superado, inicie nuevmente, verifique su conexión de red.';
                } else if (textStatus === 'abort') {
                    message = 'Request abortado.';
                } else {
                    message = 'Error desconocido: ' + jqXHR.responseText;
                }
                alert("Error: " + message + "\n" + "Status: " + jqXHR.status + "\n" + "TextStatus: " + textStatus + "\n" + "ErrorThrown: " + errorThrown);
                console.log(message);
            }
        });
    }
}